var map = {
	"./bialystok/index/section-1_pl.mdx": [
		23975,
		23975
	],
	"./bydgoszcz/index/section-1_pl.mdx": [
		19540,
		19540
	],
	"./czestochowa/index/section-1_pl.mdx": [
		19865,
		19865
	],
	"./garwolin/index/section-1_pl.mdx": [
		39126,
		39126
	],
	"./gdansk/index/section-1_pl.mdx": [
		76823,
		76823
	],
	"./gdynia/index/section-1_pl.mdx": [
		67063,
		67063
	],
	"./gliwice/index/section-1_pl.mdx": [
		42127,
		42127
	],
	"./gmina-swidnica/index/section-1_pl.mdx": [
		29594,
		29594
	],
	"./kielce/index/section-1_pl.mdx": [
		7776,
		7776
	],
	"./kolobrzeg/index/section-1_pl.mdx": [
		90254,
		90254
	],
	"./konskowola/index/section-1_pl.mdx": [
		967,
		967
	],
	"./koszalin/index/section-1_pl.mdx": [
		73960,
		73960
	],
	"./lask/index/section-1_pl.mdx": [
		32700,
		32700
	],
	"./lodz/index/section-1_pl.mdx": [
		94250,
		94250
	],
	"./lublin/index/section-1_pl.mdx": [
		57223,
		57223
	],
	"./miejsce-piastowe/index/section-1_pl.mdx": [
		79438,
		79438
	],
	"./mikolow/index/section-1_pl.mdx": [
		5719,
		5719
	],
	"./naklo/index/section-1_pl.mdx": [
		68566,
		68566
	],
	"./oborniki/index/section-1_pl.mdx": [
		19336,
		19336
	],
	"./olesnica/index/section-1_pl.mdx": [
		90479,
		90479
	],
	"./postomino/index/section-1_pl.mdx": [
		6019,
		6019
	],
	"./poznan/index/section-1_pl.mdx": [
		24331,
		24331
	],
	"./przechlewo/index/section-1_pl.mdx": [
		55080,
		55080
	],
	"./radom/index/section-1_pl.mdx": [
		45334,
		45334
	],
	"./raszkow/index/section-1_pl.mdx": [
		23930,
		23930
	],
	"./rawicz/index/section-1_pl.mdx": [
		49637,
		49637
	],
	"./ryman/index/section-1_pl.mdx": [
		30002,
		30002
	],
	"./sierakowice/index/section-1_pl.mdx": [
		48857,
		48857
	],
	"./slawno/index/section-1_pl.mdx": [
		13297,
		13297
	],
	"./slawoborze/index/section-1_pl.mdx": [
		74955,
		74955
	],
	"./stare-babice/index/section-1_pl.mdx": [
		75163,
		75163
	],
	"./szczecin/index/section-1_pl.mdx": [
		56698,
		56698
	],
	"./szemud/index/section-1_pl.mdx": [
		43251,
		43251
	],
	"./warszawa/index/section-1_pl.mdx": [
		22743,
		22743
	],
	"./wloszczowa/index/section-1_pl.mdx": [
		16052,
		16052
	],
	"./wroclaw/index/section-1_pl.mdx": [
		28596,
		28596
	],
	"./wyszkow/index/section-1_pl.mdx": [
		58381,
		58381
	],
	"./zukowo/index/section-1_pl.mdx": [
		66968,
		66968
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5450;
module.exports = webpackAsyncContext;